import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=6e7694f8&scoped=true&"
import script from "./LanguageButton.vue?vue&type=script&lang=js&"
export * from "./LanguageButton.vue?vue&type=script&lang=js&"
import style0 from "./LanguageButton.vue?vue&type=style&index=0&id=6e7694f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7694f8",
  null
  
)

export default component.exports